<template>
  <div>
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="mx-auto" outlined >
          <div class="v-lazy pa-5">
            <v-row>
              <v-col cols="6" class="text-h4">Slide</v-col>
              <v-col>
                <create class="float-end" @complete="GetData"></create>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
          <v-card-text>
            <draggable v-model="myArray" group="people" @start="drag=true" @end="drag=false" @update="UpdateSort" class="row">
              <card-sort  v-for="(item,i) in myArray" :title="item.sort" :id="item.id" :src="item.src" :key="i" @complete="GetData"></card-sort>
            </draggable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :timeout="2000" absolute
      top
      color="success"
      right>
      Update ข้อมูลแล้ว
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>

<script>
  import CardSort from "./card";
  import Create from "./create";
  import draggable from 'vuedraggable'
  export default {
    components: {
      draggable,
      CardSort,
      Create
    },
    data() {
      return {
        myArray:null,
        snackbar:false,
      };
    },

    methods: {
      GetData(){
        this.$store.commit('set_overlay',true);
         this.req.get(this.$store.getters.base_api + 'get-upload-slide/'+this.$store.getters.authen.locale).then(response=>{

          this.myArray = response.data.data;
          this.$store.commit('set_overlay',false);
        }).catch(error => {
          this.$store.commit('set_overlay',false);
        });
      },
      UpdateSort(){
        let formData = new FormData();
        formData.append('myArray',JSON.stringify(this.myArray));
        formData.append('locale',this.$store.getters.authen.locale);
        this.req.post(this.$store.getters.base_api + 'sort-upload-slide',formData)
        .then(response=>{

          this.myArray = response.data.data;
          this.snackbar = true;
        }).catch(error => {

        });
      },
  },
  mounted() {
    this.req = this.$store.getters.req;
    this.GetData();
  },



};
</script>
